import { useState, useEffect } from 'react';
import defaultImage from '../medias/images/default.jpg'

function useProfileImage() {
  const [profileImageUrl, setProfileImageUrl] = useState(defaultImage);

  useEffect(() => {

    const loadImage = () => {
      const image = sessionStorage.getItem("profileImage");

      if (!image) {
        setProfileImageUrl(defaultImage);
        return;
      }

      if (image.startsWith("data:image")) {
        setProfileImageUrl(image);
        return;
      }

      if (image.length > 100) {
        setProfileImageUrl(`data:image/jpeg;base64,${image}`);
        return;
      }

      setProfileImageUrl(defaultImage);
    };

    loadImage();

    window.addEventListener("profileImageUpdated", loadImage);

    return () => {
      window.removeEventListener("profileImageUpdated", loadImage);
    };

  }, []);

  return profileImageUrl;
}

export default useProfileImage;